import {Pipe, PipeTransform} from "@angular/core";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Pipe({
  name: "highlight",
})
export class Highlight implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string, pattern: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.getHighlightedValue(value, pattern));
  }

  private getHighlightedValue(value: string, pattern: string): string {
    if (!pattern || value == null) {
      return value;
    }

    // escaping special characters
    pattern = pattern.replace(/[-[/\]{}()*+?.,\\^$|#\s]/g, "\\$&");

    const re = new RegExp(pattern, "gi");
    const match = value.match(re);

    if (!match) {
      return value;
    }

    return value.replace(re, (match) => "<mark>" + match + "</mark>");
  }
}
